import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { PartnerConnectRequestSpin } from "partner-connect/states/partner-connect-request-spin";

export class TGRRequestSpin extends PartnerConnectRequestSpin {

    public error() {
        super.error();

        uiFlags.set(UIFlag.GAME_IN_PROGRESS, false);
        uiFlags.set(UIFlag.NO_SKIP, false);
    }
}
